"use client";

import dynamic from "next/dynamic";
import type { VidstackAudioPlayerProps } from "./VidstackAudioPlayer";

const VidstackAudioPlayer = dynamic(() => import("./VidstackAudioPlayer"), {
  ssr: false,
});

const VidstackAudioPlayerDynamicWrapper = ({
  ...props
}: VidstackAudioPlayerProps) => {
  return <VidstackAudioPlayer {...props} />;
};

export default VidstackAudioPlayerDynamicWrapper;
